// extracted by mini-css-extract-plugin
export default {"products":"Gw-z","card":"Hw-z","oosMessaging":"Iw-z"};